import { g as getTimeOptions } from './formatTime-92165ff9-e60c18fa.js';
import { g as getFormatDateTimeToParts } from './formatDateToParts-816d0f58-afa7d7f5.js';

/**
 * @param {Date} date The date to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {string} timezone The time zone to use (e.g. America/New_York).
 * The default is the runtime's default time zone.
 */
const formatTimeToParts = getFormatDateTimeToParts(getTimeOptions);
var formatTimeToParts$1 = formatTimeToParts;

export { formatTimeToParts$1 as f };
//# sourceMappingURL=formatTimeToParts-28655ac0-39d37b63.js.map
